import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import { Flex, Image } from 'lese'
import Link, { NavbarLink } from 'Components/shared/Link'
import { FadedText, Text } from 'Components/shared/Typography'

import UserStore from 'Store/user'

const NavbarContainer = styled(Flex)`
  padding: 0 8px;
  background-color: ${colors.background800};
  border-bottom: 1px solid ${colors.borderColor};
  min-height: 60px;
`

const AuthLink = styled(NavbarLink)`
  margin-left: 20px;
  margin-right: 20px;
`

const AuthText = styled(FadedText)`
  border-right: solid 2px;
  padding-right: 20px;
  line-height: 25px;
`

export default () => {
  const [seeAdmin, setSeeAdmin] = useState(false) // This permission level doesn't exist
  const { user } = UserStore.get()

  useEffect(async () => {
    setSeeAdmin(false)
  }, [])

  return (
    <NavbarContainer xAlign="space-between" yAlign>
      <Flex separation="24px" yAlign>
        <Link to="/">
          <Image src="/logo.png" />
        </Link>
        {seeAdmin && <NavbarLink to="/admin/virtual-offices">Admin</NavbarLink>}
      </Flex>

      <Flex separation="24px" yAlign>
        {user && (
          <AuthText medium>
            Logged in as: {user.username}
            {user.initials ? `, ${user.initials}` : ''}
          </AuthText>
        )}
        <AuthLink to="/logout">
          <Text medium>Logout</Text>
        </AuthLink>
      </Flex>
    </NavbarContainer>
  )
}
